// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p0-8";
export var editMode = "_p0-3";
export var headerRow = "_p0-a";
export var headerTitle = "_p0-b";
export var product = "_p0-1";
export var productDetails = "_p0-5";
export var productDivider = "_p0-7";
export var productImage = "_p0-2";
export var productInfo = "_p0-4";
export var productTitle = "_p0-6";
export var strikethrough = "_p0-9";
export var upsellProductsCard = "_p0-0";